/**
 * 按钮级权限指令 v-permission
 * @file src/directives/permission.js
 *
 * 使用方式：
 *   <el-button v-permission="'user-add'">新增用户</el-button>
 *   <el-button v-permission="['user-add', 'user-update']">操作</el-button>
 *
 * 参照 genostack 项目架构合并
 */
import { usePermissionStore } from '@/Store/permission'

export const vPermission = {
  mounted(el, binding) {
    const permissionStore = usePermissionStore()
    const { value } = binding

    if (value === undefined || value === null) return

    let hasPermission = false

    if (Array.isArray(value)) {
      // 数组模式：具有任一权限即显示（OR 逻辑）
      hasPermission = value.some(btn => permissionStore.hasPermission(btn))
    } else if (typeof value === 'string' || typeof value === 'number') {
      // 字面量模式：需精确匹配该权限
      hasPermission = permissionStore.hasPermission(String(value))
    }

    if (!hasPermission) {
      el.parentNode?.removeChild(el)
    }
  },
}

/** 注册所有自定义指令 */
export function registerDirectives(app) {
  app.directive('permission', vPermission)
}
